import React, { PropTypes, Component } from 'react';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import FilterBar from 'components/Tasks/FilterBar';
import CardList from 'components/CardList';
import TaskList from 'components/Route/Task/TaskList';
import { TaskActions } from 'actions';
import { Toggle } from 'material-ui';
import { Units } from 'Css';
import * as SvgIcons from 'components/Material/SvgIcons';
import SearchBar from 'components/Tasks/SearchBar';
import SearchList from 'components/Tasks/SearchList';
import ScrollableContainer from 'components/Tasks/ScrollableContainer';
import debounce from 'oxygen-debounce';
import { Colors } from 'Css';

const css = oxygenCss({
  root: {
    backgroundColor: Colors.theme.Light.card,
    display: 'flex',
    height: '100%',
    '@phone': {
      padding: `${Units.base}px ${Units.base * 2}px`
    }
  },
  courseFilter: {
    flex: '0 1 auto',
    borderStyle: 'none solid none none',
    borderColor: Colors.text.Dark.divider,
    borderWidth: 1
  },
  studentFilter: {
    flex: '0 1 auto',
    borderStyle: 'none solid none none',
    borderColor: Colors.text.Dark.divider,
    borderWidth: 1
  },
  tasks: {
    flex: '1 0 auto',
    width: 256,
    borderStyle: 'none solid none none',
    borderColor: Colors.text.Dark.divider,
    borderWidth: 1
  },
  toggle: {
    borderStyle: 'none none solid none',
    borderColor: Colors.text.Dark.divider,
    borderWidth: 1,
    minHeight: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box'
  }
});

export default class Tasks extends Component {
  static propTypes = {
    tasks: PropTypes.array,
    tasksFilter: PropTypes.object,
    coursesExpanded: PropTypes.bool,
    groupsExpanded: PropTypes.bool,
    students: PropTypes.array,
    courses: PropTypes.array,
    groups: PropTypes.array,
    tasksLoading: PropTypes.bool,
    studentsLoading: PropTypes.bool,
    coursesLoading: PropTypes.bool,
    groupsLoading: PropTypes.bool,
    filterMode: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  setCourseFilter = filter => {
    TaskActions.setCourseFilter(filter);
  };

  setGroupsFilter = filter => {
    TaskActions.setGroupFilter(filter);
  };

  setStudentsFilter = filter => {
    TaskActions.setStudentFilter(filter);
  };

  toggle = list => {
    TaskActions.toggleExpand(list);
  };

  selectCourse = course => {
    const { tasksFilter } = this.props;
    if (tasksFilter.courseId === course.id) {
      TaskActions.setTaskFilter({
        courseId: null
      });
    } else {
      TaskActions.setTaskFilter({
        courseId: course.id
      });
    }
  };

  selectStudent = student => {
    const { tasksFilter } = this.props;
    if (tasksFilter.userId === student.id) {
      TaskActions.setTaskFilter({
        userId: null
      });
    } else {
      TaskActions.setTaskFilter({
        userId: student.id
      });
    }
  };

  toggleCorrected = corrected => {
    TaskActions.toggleCorrected();
  };

  render() {
    const {
      tasks,
      tasksLoading,
      coursesExpanded,
      studentsExpanded,
      studentsLoading,
      coursesLoading,
      tasksFilter,
      courses,
      students,
      filterMode
    } = this.props;
    const { getIntlMessage } = this.context;
    const hasFilter = tasksFilter.userId || tasksFilter.courseId;
    return (
      <AppPage
        header={<RulerBar title={this.context.getIntlMessage('menu.Tasks')} />}
      >
        <div className={css.root}>
          <div className={css.courseFilter}>
            <SearchList
              expanded={coursesExpanded}
              onChange={this.setCourseFilter}
              onTouchTapItem={this.selectCourse}
              onRequestCollapse={this.toggle.bind(this, 'courses')}
              onRequestExpand={this.toggle.bind(this, 'courses')}
              placeholder={getIntlMessage('tasks.findCourse')}
              selected={tasksFilter.courseId}
              items={courses}
            >
              <SvgIcons.ContentContentPaste />
            </SearchList>
          </div>
          <div className={css.studentFilter}>
            <SearchList
              expanded={studentsExpanded}
              onChange={this.setStudentsFilter}
              onTouchTapItem={this.selectStudent}
              onRequestCollapse={this.toggle.bind(this, 'students')}
              onRequestExpand={this.toggle.bind(this, 'students')}
              placeholder={getIntlMessage('tasks.findStudent')}
              selected={tasksFilter.userId}
              items={students}
            >
              <SvgIcons.SocialPersonOutline />
            </SearchList>
          </div>
          <div className={css.tasks}>
            <ScrollableContainer
              header={
                <div className={css.toggle}>
                  <Toggle
                    label={getIntlMessage('tasks.showCorrected')}
                    toggled={tasksFilter.corrected}
                    onToggle={this.toggleCorrected}
                  />
                </div>
              }
            >
              <TaskList
                tasks={tasks}
                hasFilter={hasFilter}
                tasksLoading={tasksLoading}
                selected={tasksFilter.taskId}
                taskMode
              />
            </ScrollableContainer>
          </div>
        </div>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Tasks.js